import { default as configure } from '../helpers/configure.js';

export default function (config) {
    const { apiKey, appConfig = {}, options = {}, breadcrumbsApi = [] } = config;
    // overide required config
    appConfig.enableCrashReporting = true;
    appConfig.pulseCustomLoadTimeEnabled = true;
    appConfig.enablePulse = true;
    appConfig.saveIfOffline = true;
    appConfig.captureMissingRequests = true;

    options.ignore3rdPartyErrors = true;
    options.pulseCustomLoadTimeEnabled = true;

    try {
        configure(apiKey, appConfig, options, breadcrumbsApi);
    } catch (e) {}
}
